import(/* webpackMode: "eager" */ "/app/src/app/(STATIC)/layout.tsx");
